export default __webpack_public_path__ + "static/media/letter.a5b9a194.png";